module.exports = __webpack_public_path__ + "static/media/fitness-blog-post.45c60c8a.jpg";